export const tabItems = [
    { value: 'users', label: '사용자' },
    { value: 'stats', label: '사용자 통계' },
];
export const INITIAL_TAB = 'users';
